import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/ship/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/ship',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/ship',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/ship/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/ship',
    method: 'get',
    params: {
      id
    }
  })
}
export function saveIntegration(data) {
  return request({
    url: '/api/business/ship/saveIntegration',
    method: 'post',
    data
  })
}

export function getRelevancyDataById(id) {
  return request({
    url: '/api/business/ship/getRelevancyDataById',
    method: 'get',
    params: {
      id
    }
  })
}
export function noTagPage(params) {
  return request({
    url: '/api/business/ship/noTagPage',
    method: 'get',
    params
  })
}

export function shipStatusByMmsis(mmsis) {
  return request({
    url: '/api/business/ship/shipStatusByMmsis',
    method: 'post',
    data: mmsis
  })
}

export function shipTrackHistory(params) {
  return request({
    url: '/api/business/ship/shipTrackHistory',
    method: 'get',
    params
  })
}
export function yunchuanShip(params) {
  return request({
    url: '/api/business/ship/yunchuanShip',
    method: 'get',
    params
  })
}

export function maShipStatusByMmsis(mmsis) {
  return request({
    url: '/api/business/ship/maShipStatusByMmsis',
    method: 'post',
    data: mmsis
  })
}

export function maShipTrackHistory(params) {
  return request({
    url: '/api/business/ship/maShipTrackHistory',
    method: 'get',
    params
  })
}
